<template>
    <div>
        <slot name="topic" :handleTopic="handleTopic"></slot>

        <base-modal v-model:show="modal" :isTopicComponent="modal" :size="loadedTopic.type === 4 ? 'lg' : ''">
            <template #header>
                <h5 class="modal-title" :id="content.translation.slug">{{content.translation.name}}</h5>
            </template>
            <p class="mb-3">{{ content.translation.description }}</p>
            <loading-spinner v-if="loading" />
            <submit-success v-else-if="loadedTopic.answered" />
            <div v-else>
                <template v-if="showResult">
                    <base-progress
                        v-for="option in loadedTopic.options"
                        :key="option.id"
                        show-label
                        type="success"
                        :height="8"
                        :value="checkTotalPercent(loadedTopic.total, option.selections)"
                        :label="option.translation.name"
                    ></base-progress>
                </template>
                <template v-else>
                    <form role="form">
                        <div
                            v-if="loadedTopic.type !== 4"
                            class="control ml-4 mb-4">
                            <div
                                v-for="(option, i) in loadedTopic.options"
                                :key="option.id"
                                class="mt-2 custom-control custom-radio"
                            >
                                <div>
                                    <input
                                        type="radio"
                                        v-model="answer"
                                        :value="option.translation.option_id"
                                        :id="option.translation.option_id"
                                        :name="`survey-option-${i}`"
                                        class="custom-control-input"
                                    />
                                    <label
                                        class="custom-control-label"
                                        :for="option.translation.option_id"
                                    >
                                        <span
                                            v-html="optionLabel(loadedTopic.type, option.translation.slug, option.translation.name, option.icon)"
                                        ></span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <TopicSatisfactionGrade
                            v-else-if="loadedTopic.type === 4"
                            :topic="topic"
                            v-model="answer"
                        />

                        <base-input
                            v-if="loadedTopic.justify_answer"
                            :label="$t('common.justify_answer')"
                            :error="errors.first($t('common.justify_answer'))"

                        >
                            <textarea
                                v-validate="'required|min:6'"
                                v-model="justify"
                                :name="$t('common.justify_answer')"
                                class="form-control"
                                id="exampleFormControlTextarea3"
                                rows="2"
                            ></textarea>
                        </base-input>
                    </form>
                </template>
            </div>

            <template #footer>
                <div class="w-100 d-flex justify-content-between">
                    <base-button
                        type="secondary"
                        outline
                        :style="{'color': color.primary}"
                        @click="modal = false"
                    >{{$t('common.close')}}</base-button>
                    <base-button
                        v-if="!loadedTopic.answered && !submited"
                        type="primary"
                        @click="submitAnswer"
                    >{{$t('common.send')}}</base-button>
                </div>
            </template>
        </base-modal>
    </div>
</template>

<script>
import BaseModal from "../../../argon/components/Modal";
import BaseButton from "../../../argon/components/BaseButton";
import BaseProgress from "../../../argon/components/BaseProgress";
import BaseInput from "../../../argon/components/Inputs/BaseInput";

import LoadingSpinner from "../../Common/LoadingSpinner";
import SubmitSuccess from "../../Common/SubmitSuccess";

import TopicSatisfactionGrade from './TopicSatisfactionGrade';

export default {
    name: "Topic",
    components: {
        BaseModal,
        BaseButton,
        LoadingSpinner,
        SubmitSuccess,
        BaseProgress,
        BaseInput,
        TopicSatisfactionGrade
    },
    props: {
        content: {
            type: Object,
            required: true
        },
        parents: Object,
        final: Boolean
    },
    data() {
        return {
            loadedTopic: {},
            modal: false,
            loading: false,
            submited: false,
            showResult: false,
            justify: "",
            answer: ""
        };
    },
    watch: {
        topic(value, oldValue) {
            if (value !== oldValue) {
                this.loadedTopic = value;
            }
        }
    },
    computed: {
        color() {
            return this.$store.getters.COLOR;
        },
        topic() {
            return this.$store.getters.LOADED_FINAL_TOPIC;
        },
        submodules() {
            const submodules = new URLSearchParams(window.location.search);
            return submodules.getAll("submodules[]");
        },

    },

    methods: {
        async loadTopic() {
            this.loading = true;
            if (this.final) {
                await this.$store
                    .dispatch("LOAD_FINAL_CONTENT_TOPIC", {
                        parents: this.parents,
                        id: this.content.id,
                        submodules: this.submodules
                    })
                    .then(() => (this.loading = false));
            } else {
                window.axios
                    .get(`/api/app/topic/${this.content.id}`, {
                        params: {
                            submodules: this.submodules
                        }
                    })
                    .then(res => (this.loadedTopic = res.data.data))
                    .catch(err => console.error(err))
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        handleTopic() {
            this.modal = true;
            this.loadTopic(true);
        },
        optionLabel(type, slug, name, icon) {
            let count = slug[0];
            let starRating = `<i class="survey-star-rating mdi mdi-star"></i>`;
            switch (type) {
                case 1:
                    return name;
                    break;
                case 2:
                    if (count == 1) return starRating.repeat(count);
                    if (count == 2) return starRating.repeat(count);
                    if (count == 3) return starRating.repeat(count);
                    if (count == 4) return starRating.repeat(count);
                    if (count == 5) return starRating.repeat(count);
                    break;
                case 3:
                    if (icon == 5)
                        return `<i class="nch-topic-rating mdi mdi-emoticon-angry-outline"></i><span class="nch-topic-rating--text">${name}</span>`;
                    if (icon == 4)
                        return `<i class="nch-topic-rating mdi mdi-emoticon-sad-outline"></i><span class="nch-topic-rating--text">${name}</span>`;
                    if (icon == 3)
                        return `<i class="nch-topic-rating mdi mdi-emoticon-neutral-outline"></i><span class="nch-topic-rating--text">${name}</span>`;
                    if (icon == 2)
                        return `<i class="nch-topic-rating mdi mdi-emoticon-happy-outline"></i><span class="nch-topic-rating--text">${name}</span>`;
                    if (icon == 1)
                        return `<i class="nch-topic-rating mdi mdi-emoticon-excited-outline"></i><span class="nch-topic-rating--text">${name}</span>`;
                    break;

                default:
                    break;
            }
        },
        submitAnswer() {
            if (!this.answer) {
                this.$notify({
                    type: "danger",
                    message: this.$t("common.select_one")
                });
                return;
            }
            this.$validator.validate().then(async valid => {
                if (valid) {
                    this.loading = true;
                    await axios
                        .post(
                            `/api/app/topic/${this.loadedTopic.id}/answer/${this.answer}`,
                            {
                                justify: this.justify,
                                parents: this.parents,
                            }
                        )
                        .then(res => {
                            this.loadedTopic = res.data.data;
                            this.showResult = true;
                            this.submited = true;
                            this.$emit("submited");
                        })
                        .catch(err => {
                            console.error(err);
                            this.showResult = false;
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            });
        },
        checkTotalPercent(total, selections) {
            const res = (selections / total) * 100;
            return Math.round((res + Number.EPSILON) * 100) / 100;
        }
    }
};
</script>

<style>
.survey-star-rating {
    color: #e6e61a;
    font-size: 1.2rem;
}

.nch-topic-rating {
    font-size: 1.7rem;
    position: absolute;
    top: -10px;
}

.nch-topic-rating--text {
    font-size: 0.9rem;
    margin-left: 2.7rem;
}
</style>
